import type { PartnerData } from '@beat-venues/common-types';
import { type VariantProps, cva } from 'class-variance-authority';
import { twMerge } from 'tailwind-merge';

import { Partner } from '../../atoms';
import type { CommonProps } from '../../types';

export interface PartnerListProps
    extends CommonProps,
        VariantProps<typeof PartnerListStyles> {
    partners: PartnerData[];
}

export const PartnerListStyles = cva(
    'flex flex-wrap items-center justify-center gap-8 '
);

export const PartnerList = ({
    className,
    partners,
    testId = 'partner-list',
    ...props
}: PartnerListProps): JSX.Element => {
    return (
        <ul
            className={twMerge(PartnerListStyles({ className }))}
            {...props}
            data-testid={testId}
        >
            {partners.map((partner) => (
                <Partner
                    key={partner.id}
                    href={partner.href}
                    image={partner.image}
                />
            ))}
        </ul>
    );
};
